export default "__VITE_ASSET__B7O65t$e__"